import React, { useEffect, useState } from 'react';
import { UserSummaryType } from '../../../api/types/user/user-summary.type';
import { Dialog } from 'primereact/dialog';
import { AddUserDialog } from '../add-user-dialog/add-user-dialog';
import { FindUser } from '../../../pages/find-user-page/find-user';
import { UserPage } from '../../../pages/user-page/user-page';
import { UserType } from '../../../api/types/user/user-type';
import { UserPageHeader } from '../../../pages/user-page/header/user-page-header';
import { UserPageDialog } from './user-page-dialog/user-page-dialog';
import { Button } from 'primereact/button';

interface SearchUsersDatamodel {
  title: string;
  role?: UserType;
  selectedUserToDisplay: UserSummaryType | undefined;
  onSelectedUserDialogHide: () => any;
  onUserCreated?: (user: UserSummaryType) => void;
  // TODO userType as optional
}

const SearchUsers: React.FC<SearchUsersDatamodel> = ({
  title,
  role,
  selectedUserToDisplay,
  onSelectedUserDialogHide,
  onUserCreated,
}) => {
  const [createNewUserActive, setCreateNewUserActive] = useState(false);
  const [selectedUser, setSelectedUser] = useState<
    UserSummaryType | undefined
  >();

  useEffect(() => {
    setSelectedUser(selectedUserToDisplay);
  }, [selectedUserToDisplay]);

  const handleAddUserClick = () => {
    setCreateNewUserActive(true);
    console.log('handleAddUserClick is clicked');
  };

  const handleOnApprove = async (
    selectedUsers: UserSummaryType[],
    setLoading: (loading: boolean) => void,
  ) => {
    console.log();
  };

  const handleUserFindClick = (user: UserSummaryType | undefined) => {
    setSelectedUser(user);
  };
  const closeDialog = () => handleUserFindClick(undefined);

  const getTooltipTextByRole = () => {
    switch (role) {
      case UserType.STUDENT:
        return 'הוספת סטודנט חדש';
      case UserType.LECTURER:
        return 'הוספת מרצה חדש';
      case UserType.ADMINISTRATION:
        return 'הוספת עובד מנהלה חדש';
      default:
        return 'הוספת משתמש חדש';
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
        <div style={{ width: '100%' }}>
          <FindUser
            displayTable={false}
            onApprove={handleOnApprove}
            onUserSelected={handleUserFindClick}
            multiple={false}
            role={role}
          />
        </div>
        <Button
          icon="pi pi-plus"
          className="p-button-rounded p-button-success"
          onClick={handleAddUserClick}
          tooltip={getTooltipTextByRole()}
          tooltipOptions={{ position: 'bottom' }}
          style={{
            width: '48px',
            height: '48px',
            fontSize: '18px',
          }}
        />
      </div>

      <UserPageDialog
        userRole={role}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        closeDialog={closeDialog}
        onHide={() => {
          handleUserFindClick(undefined);
          onSelectedUserDialogHide();
        }}
      />

      <Dialog
        header="הוספת משתמש"
        visible={createNewUserActive}
        style={{
          width: '500px',
          height: '100vh',
          minHeight: '100vh',
          borderRadius: '0 8px 8px 0', // Only right-side border radius (top-right, bottom-right)

          backgroundColor: 'white',
          padding: '8px',
          position: 'absolute',
          left: '0px', // Positions it from the left edge
          top: '0', // Aligns to the top of the viewport
          margin: '0', // Removes any margin
          transform: 'none', // Removes any transform that might affect positioning
          display: 'flex', // Using flex for better content organization
          flexDirection: 'column', // Stacks header and content vertically
        }}
        onHide={() => {
          setCreateNewUserActive(false);
        }}
      >
        <div style={{ height: '8px' }} />
        <div>
          <AddUserDialog
            role={role}
            onHide={() => setCreateNewUserActive(false)}
            onUserCreated={onUserCreated}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default SearchUsers;
